import PropTypes from 'prop-types';
import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import StandardForm from './StandardForm';
import DialogForm from './DialogForm';

const FormRenderer = ({
    formFields,
    submit,
    initialValues,
    submitText,
    validationSchema,
    formType,
    removeSubmit,
    closeDialog,
}) => {
    const Form = formType === 'standard' ? StandardForm : DialogForm;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting, setValues }) => {
                submit(values, setSubmitting, setValues);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => (
                <>
                    <Form
                        formFields={formFields}
                        submitText={submitText}
                        submitForm={submitForm}
                        errors={errors}
                        touched={touched}
                        values={values}
                        removeSubmit={removeSubmit}
                        closeDialog={closeDialog}
                        isSubmitting={isSubmitting}
                    />
                </>
            )}
        </Formik>
    );
};
export default FormRenderer;

FormRenderer.propTypes = {
    formFields: PropTypes.array.isRequired,
    initialValues: PropTypes.object,
    submit: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    formType: PropTypes.string,
};

FormRenderer.defaultProps = {
    initialValues: null,
    submitText: 'Submit',
    formType: 'standard',
};
